import { useState, useEffect, useRef } from "react";
import { FilterWrapper, Options, Option, CustomImageWrapper } from "./styles";
import filterGrey from "../../../icons/webicons/filter-gray.svg";
import filterWhite from "../../../icons/webicons/filter-white.svg";
import Checkbox from "../checkbox";
import Div from "../division";
import { MEASURMENT_FILTERS } from "../../../../measurements/constants";
import dropDown from "../../../icons/webicons/dropdown-drkgray.svg";
import { withTranslation } from "react-i18next";
import { INTERVAL_INFO } from "../../../../graph/3540/helpers/constants";

function Filter({
  options: optionsProp = [], selectAllVisible, label, disableFilter,
  filterList: filterListCallback, handleCollapseExpand, isloading, t
}) {
  const [showoptions, setShowoptions] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [options, setOptions] = useState(
    optionsProp.map((o) => ({ option: o.option, value: o.value, checked: o.checked }))
  );
  const filterListRef = useRef([]);
  const nodeRef = useRef(null);

  useEffect(() => {
    setOptions(optionsProp.map((o) => ({ option: o.option, value: o.value, checked: o.checked })));
  }, [optionsProp]);

  useEffect(() => {
    const hideOnClickOutside = (e) => {
      if (nodeRef.current && !nodeRef.current.contains(e.target)) {
        setShowoptions(false);
      }
    };
    document.addEventListener("mousedown", hideOnClickOutside);
    return () => document.removeEventListener("mousedown", hideOnClickOutside);
  }, []);

  const handleViewAll = (i, opts) => {
    const filter = opts[i];
    if (filter.checked) {
      if (MEASURMENT_FILTERS.VIEW_ALL.option === filter.option) {
        for (let a = 1; a < opts.length; a++) opts[a].checked = false;
      } else {
        const index = opts.findIndex((f) => f.option === MEASURMENT_FILTERS.VIEW_ALL.option);
        if (index >= 0) opts[index].checked = false;
      }
    }
    return opts;
  };

  const handleChange = (i) => {
    const updatedOptions = [...options];
    updatedOptions[i].checked = !updatedOptions[i].checked;
    if (updatedOptions[i].checked) {
      filterListRef.current.push(updatedOptions[i].value);
    } else {
      const ind = filterListRef.current.indexOf(updatedOptions[i].value);
      filterListRef.current.splice(ind, 1);
      setSelectAll(false);
    }
    const finalOptions = !selectAllVisible
      ? handleViewAll(i, updatedOptions)
      : updatedOptions;
    filterListCallback(finalOptions, filterListRef.current);
    setOptions(finalOptions);
    if (handleCollapseExpand) handleCollapseExpand(showoptions);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const updatedOptions = [...options];
      filterListRef.current = [];
      updatedOptions.forEach((option) => {
        option.checked = true;
        filterListRef.current.push(option.value);
      });
      setOptions(updatedOptions);
      setSelectAll(true);
      filterListCallback(updatedOptions, filterListRef.current);
    } else {
      setSelectAll(false);
    }
  };

  const leftCssValue = selectAllVisible === false ? "initial" : "-144px";

  return (
    <FilterWrapper ref={nodeRef} showoptions={showoptions} data-testid="filter">
      {label ? (
        <section onClick={() => setShowoptions((v) => !v)}>
          <span>{t("Filter")}</span>
          <img src={dropDown} alt="dropDown-icon" />
        </section>
      ) : (
        <CustomImageWrapper
          src={showoptions || disableFilter ? filterWhite : filterGrey}
          onClick={() => setShowoptions((v) => !v)}
          disableFilter={disableFilter}
          alt="filter-icon"
        />
      )}
      {showoptions && !isloading ? (
        <Options data-testid="options" leftCssValue={leftCssValue}>
          {selectAllVisible ? (
            <Option>
              <Checkbox
                data-testid="option-checkbox"
                onChange={handleSelectAll}
                custom
                background="#5582BA"
                checked={selectAll}
              />
              <Div>Select All</Div>
            </Option>
          ) : undefined}
          {options.map((item, i) => (
            <Option key={i}>
              <Checkbox
                key={i}
                data-testid="option-checkbox"
                custom
                background="#5582BA"
                checked={item.checked}
                onChange={() => {
                  handleChange(i);
                  setTimeout(() => setShowoptions(false), INTERVAL_INFO.thousand);
                }}
                data-test="option-checkbox"
              />
              <Div onClick={() => handleChange(i)}>{t(item.option)}</Div>
            </Option>
          ))}
        </Options>
      ) : (
        ""
      )}
    </FilterWrapper>
  );
}

export default withTranslation()(Filter);
